import React from 'react';

// Refresh/Reload Icon Component
export interface IconProps {
    width?: number;
    height?: number;
    className?: string;
}

export const RefreshIcon: React.FC<IconProps> = ({
    width = 18,
    height = 18,
    className = ''
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className={className}
    >
        <polyline points="23,4 23,10 17,10"/>
        <polyline points="1,20 1,14 7,14"/>
        <path d="M20.49,9A9,9,0,0,0,5.64,5.64L1,10m22,4l-4.64,4.36A9,9,0,0,1,3.51,15"/>
    </svg>
);

export default RefreshIcon;
